module.exports = __webpack_public_path__ + "img/Islamabad-Pakistan.30065c9f.webp";